import { deserializeDigitalAsset, DigitalAsset } from "@metaplex-foundation/mpl-token-metadata";
import { assertAccountExists, Context, Pda, publicKey } from "@metaplex-foundation/umi";
import { PublicKey } from "@solana/web3.js";
import { publicKey as publicKeySerializer, string } from "@metaplex-foundation/umi/serializers";

export async function fetchDigitalAsset(
  context: Pick<Context, "rpc" | "eddsa" | "programs">,
  mint: PublicKey
): Promise<DigitalAsset> {
  const [metadata] = findMetadataPda(context, { mint });
  const [edition] = findMasterEditionPda(context, { mint });
  const mintString = publicKey(mint.toBase58());
  const [mintAccount, metadataAccount, editionAccount] = await context.rpc.getAccounts([mintString, metadata, edition]);
  assertAccountExists(mintAccount, "Mint");
  assertAccountExists(metadataAccount, "Metadata");
  return deserializeDigitalAsset(mintAccount, metadataAccount, editionAccount.exists ? editionAccount : undefined);
}

export function findMetadataPda(
  context: Pick<Context, "eddsa" | "programs">,
  seeds: {
    /** The address of the mint account */
    mint: PublicKey;
  }
): Pda {
  const programId = context.programs.getPublicKey("mplTokenMetadata", "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s");
  return context.eddsa.findPda(programId, [
    string({ size: "variable" }).serialize("metadata"),
    publicKeySerializer().serialize(programId),
    publicKeySerializer().serialize(seeds.mint),
  ]);
}

export function findMasterEditionPda(
  context: Pick<Context, "eddsa" | "programs">,
  seeds: {
    /** The address of the mint account */
    mint: PublicKey;
  }
): Pda {
  const programId = context.programs.getPublicKey("mplTokenMetadata", "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s");
  return context.eddsa.findPda(programId, [
    string({ size: "variable" }).serialize("metadata"),
    publicKeySerializer().serialize(programId),
    publicKeySerializer().serialize(seeds.mint),
    string({ size: "variable" }).serialize("edition"),
  ]);
}
